import React from 'react';

const modalBackdropStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalContentStyle = {
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '20px',
  maxWidth: '400px',
  width: '90%',
  boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
  zIndex: 1001,
};

const closeButtonStyle = {
  marginTop: '15px',
  padding: '8px 16px',
  backgroundColor: '#007bff',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
};

const EmailTemplateSelector = ({ templates, onSelect, onClose }) => {
  return (
    <div style={modalBackdropStyle} onClick={onClose} role="dialog" aria-modal="true">
      <div style={modalContentStyle} onClick={e => e.stopPropagation()}>
        <h3>Select Email Template</h3>
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          {templates.map(template => (
            <li key={template.id} style={{ marginBottom: '10px' }}>
              <button
                onClick={() => onSelect(template)}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '4px',
                  border: '1px solid #ccc',
                  backgroundColor: '#f9f9f9',
                  cursor: 'pointer',
                  textAlign: 'left',
                }}
              >
              {template.template_name}
              </button>
            </li>
          ))}
        </ul>
        <button style={closeButtonStyle} onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default EmailTemplateSelector;
